import { render, staticRenderFns } from "./orderCascader.vue?vue&type=template&id=4cf6f0a4&scoped=true"
import script from "./orderCascader.vue?vue&type=script&lang=js"
export * from "./orderCascader.vue?vue&type=script&lang=js"
import style0 from "./orderCascader.vue?vue&type=style&index=0&id=4cf6f0a4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf6f0a4",
  null
  
)

export default component.exports